/* eslint-disable indent */
import styled from 'styled-components';
import { attachmentsTypeNames } from 'newJs/config/theme';

const Attachment = styled.div.attrs((props) => ({
    className: props.isImage ? 'is-image' : null
}))`
    background-color: var(--theme-attachment-item-bg);
    position: relative;
    display: flex;
    border: 1px solid var(--theme-attachment-item-border);
    overflow: hidden;
    img {
        left: 0;
        object-fit: scale-down;
        position: absolute;
        top: 0;
    }
    .item-fsize {
        color: var(--theme-attachment-grid-text);
    }
    .item-loader {
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    &.is-image {
        .item-extension-icon {
            display: none;
        }
        .item-name__value {
            padding: 0 ${({ theme }) => 2 * theme.gridGutterWidth}px;
        }
        .item-content {
            width: 100%;
            padding: 0;
            visibility: hidden;
            opacity: 0;
            transition: opacity 0.3s linear;
        }
        .item-fsize {
            color: white;
        }
        &:hover {
            .item-content {
                background-color: var(--attachments-image-hover);
                opacity: 1;
                visibility: visible;
                z-index: 1;
            }
            a {
                color: var(--color-white);
                &:hover {
                    color: var(--color-white);
                }
            }
        }
        /* Mobiles */
        @media(pointer: coarse) {
            padding: 0;
            img {
                z-index: 1;
            }
            .item-content {
                background-color: var(--attachments-image-hover);
                opacity: 1;
                visibility: visible;
            }
            .item-name__value {
                visibility: hidden;
            }
            .item-fsize {
                display: none;
            }
            .item-actions {
                background-color: var(--attachments-image-hover);
                flex-flow: row nowrap;
                flex-grow: 0;
                justify-content: center;
                position: relative;
                width: 100%;
                z-index: 2;
            }
            .item-action {
                color: var(--color-white);
            }
        }
    }
    .item-extension-icon {
        &--unknown {
            color: var(--color-fire);
        }
        ${() => {
            // Loop through the attachment colors and generate the background styles dynamically
            return Object.keys(attachmentsTypeNames).map((type) => {
                const color = attachmentsTypeNames[type];
                return `
                &--${type} {
                    color: var(--${color});
                }
                `;
            }).join('');
        }}
    }
`;

export default Attachment;
